import { useScript } from "hooks";

function AttentiveMobile({ id }: { id: string }) {
  useScript(`https://cdn.attn.tv/${id}/dtag.js`);

  return null;
}

export default AttentiveMobile;
